import axios from 'axios';

export const apiRegisterForTraining = (id, payload) => axios.post(`/api/training/${id}/registration`, payload);
